import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const initialState = {
    sidebar: {
        open: false,
    },
};

export const settingsSlice = createSlice({
    name: "settings",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        setSidebarOpen: (state, action) => {
            state.sidebar.open = Boolean(action.payload);
        },
    },
});

export const useSettingsSelector = () => useSelector((state) => state.settings);

export const { reset, setSidebarOpen } = settingsSlice.actions;

export default settingsSlice.reducer;
